import { InjectionToken } from '@angular/core';
import { EnvironmentConfigDto } from '../interfaces/environment-config-dto';

export const envToken = new InjectionToken<EnvironmentConfigDto>('ENV');
